<header class="relative fixed top-0 left-0 right-0 z-[1000] h-[7rem] bg-[#2b3890] overflow-hidden">

  <!-- Decorative lines background image -->
  <div class="clip-bg-lines"></div>

  <!-- Inner layout -->
  <div class="relative h-full max-w-[160rem] mx-auto px-[3.2rem] flex items-center gap-[3.2rem]">

    <!-- Logo -->
    <a routerLink="/" class="shrink-0 no-underline">
      <img src="/images/app title.svg" alt="Arch of Traits" class="h-[4.5rem]" />
    </a>

    <!-- Desktop nav — hidden below 1230px -->
    <nav class="hidden min-[1230px]:flex items-center gap-[2rem] flex-1 ml-[1.5rem]">
      @for (link of navLinks; track link.route) {
      <a [routerLink]="link.route" routerLinkActive="opacity-60"
        class="text-white no-underline text-[1.2rem] font-semibold tracking-[0.12em] whitespace-nowrap transition-opacity duration-200 hover:opacity-75">
        {{ link.label }}
      </a>
      }
    </nav>

    <!-- Desktop CTA buttons — hidden below 1230px -->
    @if (!hideActions) {
    <div class="hidden min-[1230px]:flex items-center gap-[1.2rem] ml-auto shrink-0">
      <button routerLink="/redeem"
        class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1rem] text-[1.2rem] font-bold tracking-[0.08em] whitespace-nowrap cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
        REDEEM ASSESSMENT
      </button>
      @if (isLoggedIn()) {
      <button routerLink="/profile"
        class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1rem] text-[1.2rem] font-bold tracking-[0.08em] whitespace-nowrap cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
        <!-- {{ profileData()?.current_role?.role === ERole.EMPLOYER ? 'MY TEAM' : 'MY PROFILE' }} -->
          MANAGE
      </button>
      <button (click)="onSignOut()"
        class="bg-transparent text-white text-[1.2rem] font-semibold tracking-[0.12em] whitespace-nowrap cursor-pointer border-none transition-opacity duration-200 hover:opacity-75 p-0">
        SIGN OUT
      </button>
      } @else {
      <button routerLink="/sign-in"
        class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1rem] text-[1.2rem] font-bold tracking-[0.08em] whitespace-nowrap cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
        SIGN IN
      </button>
      }
    </div>
    }

    <!-- Hamburger button — visible below 1230px -->
    <button (click)="toggleMenu()"
      class="flex min-[1230px]:hidden ml-auto items-center justify-center w-[4rem] h-[4rem] bg-transparent border-none cursor-pointer p-0 shrink-0"
      aria-label="Toggle navigation menu">
      @if (!isMenuOpen()) {
      <!-- Hamburger icon -->
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5"
        stroke-linecap="round">
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
      }
    </button>

  </div>
</header>

<!-- Backdrop overlay -->
@if (isMenuOpen()) {
<div class="fixed inset-0 z-[999] bg-black/50 min-[1230px]:hidden" (click)="closeMenu()"></div>
}

<!-- Slide-in drawer -->
<div
  class="fixed top-0 right-0 z-[1001] h-full w-[28rem] bg-[#2b3890] flex flex-col pt-[7rem] pb-[3.2rem] px-[2.4rem] transition-transform duration-300 ease-in-out min-[1230px]:hidden"
  [class.translate-x-0]="isMenuOpen()" [class.translate-x-full]="!isMenuOpen()">
  <!-- Drawer nav links -->
  <nav class="flex flex-col gap-[0.4rem] mt-[1.6rem]">
    @for (link of navLinks; track link.route) {
    <a [routerLink]="link.route" routerLinkActive="opacity-60" (click)="closeMenu()"
      class="text-white no-underline text-[1.5rem] font-semibold tracking-[0.12em] py-[1.2rem] border-b border-white/10 transition-opacity duration-200 hover:opacity-75">
      {{ link.label }}
    </a>
    }
  </nav>

  <!-- Drawer CTA buttons -->
  @if (!hideActions) {
  <div class="flex flex-col gap-[1.2rem] mt-auto">
    <button routerLink="/redeem" (click)="closeMenu()"
      class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1.2rem] text-[1.3rem] font-bold tracking-[0.08em] cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
      REDEEM ASSESSMENT
    </button>
    @if (isLoggedIn()) {
    <button routerLink="/profile" (click)="closeMenu()"
      class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1.2rem] text-[1.3rem] font-bold tracking-[0.08em] cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
      <!-- {{ profileData()?.current_role?.role === ERole.EMPLOYER ? 'MY TEAM' : 'MY PROFILE' }}  -->
        MANAGE
    </button>
    <button (click)="onSignOut(); closeMenu()"
      class="bg-transparent text-white text-[1.2rem] font-semibold tracking-[0.12em] cursor-pointer border-none transition-opacity duration-200 hover:opacity-75 py-[1.2rem]">
      SIGN OUT
    </button>
    } @else {
    <button routerLink="/sign-in" (click)="closeMenu()"
      class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1.2rem] text-[1.5rem] font-bold tracking-[0.08em] cursor-pointer border-none transition-opacity duration-200 hover:opacity-85">
      SIGN IN
    </button>
    }
  </div>
  }
</div>
